import { combineReducers } from 'redux';

import signIn from './auth/signIn';
import manager from './auth/manager';

import language from './common/language';
import loader from './common/loader';
import menu from './common/menu';
import code from './common/code';
import systemSetting from './common/systemSetting';
import shopNotification from './common/shopNotification';
import callNotification from './common/callNotification';
import scorecard from './common/scorecard';
import billing from './common/billing';
import popup from './common/popup';
import itemNotification from './common/itemNotification';

import shopInfo from './shop/shopInfo';
import shopManagerInfo from './shop/shopManagerInfo';
import shopGameRoundOptionSetting from './shop/shopGameRoundOptionSetting';
import shopDrivingRangeOptionSetting from './shop/shopDrivingRangeOptionSetting';
import shopClientRealTimeControlOptionSetting from './shop/shopClientRealTimeControlOptionSetting';
import shopClientInfo from './shop/shopClientInfo';

import gameHistory from './gameHistory/list';

import realTimeCommunicationHub from './clientStatus/hub';
import clientStatusList from './clientStatus/list';
import clientStatusInfo from './clientStatus/info';

import paymentInfo from './billing/paymentInfo';
import recurringPayment from './billing/recurringPayment';
import payment from './billing/payment';
import bills from './billing/bills';
import itemPayment from './billing/itemPayment';

import notice from './customerService/notice';
import qna from './customerService/qna';

import tournamentList from './tournament/list';
import tournamentOpen from './tournament/open';
import tournamentDetails from './tournament/details';

import inventory from './inventory/list';
import itemShop from './itemShop/list';

// import shopNotify from './common/shopNotify';
// import dashboard from './home/dashboard';
// import clientStatus from './home/clientStatus';
// import shop from './home/shop';

export default combineReducers({
    signIn,
    manager,

    language,
    loader,
    menu,
    code,
    systemSetting,
    shopNotification,
    callNotification,
    scorecard,
    billing,
    popup,
    itemNotification,

    shopInfo,
    shopManagerInfo,
    shopClientInfo,
    shopGameRoundOptionSetting,
    shopDrivingRangeOptionSetting,
    shopClientRealTimeControlOptionSetting,
    

    gameHistory,

    realTimeCommunicationHub,
    clientStatusList,
    clientStatusInfo,

    paymentInfo,
    recurringPayment,
    payment,
    bills,
    itemPayment,

    notice,
    qna,

    tournamentList,
    tournamentOpen,
    tournamentDetails,

    inventory,
    itemShop,

    // shopNotify,
    // dashboard,
    // clientStatus,
    // shop,
});
